
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

interface UseSEOProps {
  title?: string;
  description?: string;
  keywords?: string;
  image?: string;
  type?: 'website' | 'article' | 'product' | 'service';
  noindex?: boolean;
  nofollow?: boolean;
}

export const useSEO = (props: UseSEOProps) => {
  const location = useLocation();

  useEffect(() => {
    // Structured data for healthcare organization
    const structuredData = {
      "@context": "https://schema.org",
      "@type": "HealthcareOrganization",
      "name": "Médicace",
      "description": "Plateforme de santé digitale complète pour la gestion des soins médicaux",
      "url": window.location.origin,
      "logo": `${window.location.origin}/lovable-uploads/8003781b-4d38-497c-8862-00124549a126.png`,
      "contactPoint": {
        "@type": "ContactPoint",
        "telephone": "+33-1-23-45-67-89",
        "contactType": "customer service",
        "availableLanguage": "French"
      },
      "address": {
        "@type": "PostalAddress",
        "addressCountry": "FR",
        "addressLocality": "Paris"
      },
      "sameAs": [
        "https://www.facebook.com/medicace",
        "https://www.linkedin.com/company/medicace",
        "https://twitter.com/medicace"
      ],
      "potentialAction": {
        "@type": "SearchAction",
        "target": `${window.location.origin}/services?q={search_term_string}`,
        "query-input": "required name=search_term_string"
      },
      "offers": {
        "@type": "Offer",
        "category": "Soins de santé",
        "description": "Services de téléconsultation et suivi médical"
      }
    };

    // Add or update structured data
    let script = document.querySelector('script[type="application/ld+json"]') as HTMLScriptElement;
    if (!script) {
      script = document.createElement('script');
      script.type = 'application/ld+json';
      document.head.appendChild(script);
    }
    script.textContent = JSON.stringify(structuredData);

  }, [location.pathname]);

  return null;
};
